// console.log("process.env.REACT_APP_BASE_URL",process.env.REACT_APP_BASE_URL)
const RUNTIME = window.__RUNTIME_CONFIG__ || window._env_ || {};
console.log("RUNTIME CONFIG:", RUNTIME);

const dev = {
  
  // API_AGENT: "https://vlmai.voicera-analytics.com",
  // BASE_URL: "http://localhost:8002",
  // BASE_URL:  "https://vlmai.voicera-analytics.com",
  // 
  // BASE_URL:  "http://localhost:8001",
  BASE_URL:  "https://vlmliteapi-prod.voiceracx.ai",
  CLOUD_STORAGE_BASE_URL: "https://document-microservice.voiceracx.ai",
  // API_AGENT: RUNTIME.API_AGENT || "https://vlmai.voicera-analytics.com",
  // BASE_URL: "https://b4f61cb56c29.ngrok-free.app",
  // BASE_URL: "https://regularly-handles-container-living.trycloudflare.com",
  // API_WEBSOCKET: "wss://47.85.41.83:8000",
  API_WEBSOCKET: "wss://vlmliteapi-prod.voiceracx.ai",
  IFRAME_CHAT_URL: "https://chat-microservice.voiceracx.ai",
  IFRAME_WEBSOCKET_URL: "https://chat-microservice.voiceracx.ai",
  VIDEO_APP_URL: "https://video-in-flex-functions-2927-dev.twil.io",
  // Testing Framework Backend (separate from main backend)
  TESTING_API_BASE_URL: "https://vlm-shield.voiceracx.ai/api",
  // External Service URLs
  PUBLIC_URL: RUNTIME.PUBLIC_URL || "http://localhost:3000",
  FRONTEND_URL: RUNTIME.FRONTEND_URL || "http://localhost:3000",
  VLM_UI_URL: RUNTIME.VLM_UI_URL || "http://localhost:3000",
  SCHEDULER_URL:
    RUNTIME.SCHEDULER_URL ||
    process.env.REACT_APP_SCHEDULER_URL ||
    "https://gendialer.voiceracx.ai/auth/login?redirect=/gendialer/signin",
  /** GenDialer API (signin for scheduler handoff); not the same host as VLM lite API */
  GENDIALER_API_BASE_URL:
    RUNTIME.GENDIALER_API_BASE_URL ||
    process.env.REACT_APP_GENDIALER_API_BASE_URL ||
    "https://gendialer.voiceracx.ai",
  FB_APP_ID: RUNTIME.FB_APP_ID || "24067448326255766",
  GOOGLE_CLIENT_ID: RUNTIME.GOOGLE_CLIENT_ID || process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
  MICROSOFT_CLIENT_ID: RUNTIME.MICROSOFT_CLIENT_ID || process.env.REACT_APP_MICROSOFT_CLIENT_ID || "",
  MICROSOFT_TENANT_ID: RUNTIME.MICROSOFT_TENANT_ID || process.env.REACT_APP_MICROSOFT_TENANT_ID || "common",
  App_URL: RUNTIME.App_URL || "https://vlmlite.voiceracx.ai",
  // Audio S3 Configuration
  AUDIO_S3_BUCKET: RUNTIME.AUDIO_S3_BUCKET || process.env.REACT_APP_AUDIO_S3_BUCKET || "vlmtestdata",
  AUDIO_S3_REGION: RUNTIME.AUDIO_S3_REGION || process.env.REACT_APP_AUDIO_S3_REGION || "us-east-1",
  AUDIO_S3_BASE_URL: RUNTIME.AUDIO_S3_BASE_URL || process.env.REACT_APP_AUDIO_S3_BASE_URL || "https://vlmtestdata.s3.us-east-1.amazonaws.com",
  AUDIO_S3_PATH: RUNTIME.AUDIO_S3_PATH || process.env.REACT_APP_AUDIO_S3_PATH || "Botnoi+Voices/A_Records",
};

const prod = {
  BASE_URL: RUNTIME.BASE_URL || process.env.REACT_APP_BASE_URL || "https://vlmliteapi-prod.voiceracx.ai",
  CLOUD_STORAGE_BASE_URL: "https://document-microservice.voiceracx.ai",
  API_AGENT: RUNTIME.API_AGENT || process.env.REACT_APP_API_AGENT || "https://vlmliteapi-prod.voiceracx.ai",
  API_WEBSOCKET: RUNTIME.API_WEBSOCKET || process.env.REACT_APP_API_WEBSOCKET || "wss://vlmliteapi-prod.voiceracx.ai",
  // Testing Framework Backend (separate from main backend)
  TESTING_API_BASE_URL: "https://vlm-shield.voiceracx.ai/api",

  PUBLIC_URL: RUNTIME.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL || "https://vlmlite.voiceracx.ai",
  FRONTEND_URL: RUNTIME.FRONTEND_URL || "https://vlmlite.voiceracx.ai",
  VLM_UI_URL: RUNTIME.VLM_UI_URL || "https://vlmlite.voiceracx.ai",
  AUTH_URL: RUNTIME.AUTH_URL || "https://vlmlite.voiceracx.ai",
  LOGIN_URL: RUNTIME.LOGIN_URL || "https://vlmlite.voiceracx.ai/auth/login",

  SCHEDULER_URL:
    RUNTIME.SCHEDULER_URL ||
    process.env.REACT_APP_SCHEDULER_URL ||
    "https://gendialer.voiceracx.ai/auth/login?redirect=/gendialer/signin",
  GENDIALER_API_BASE_URL:
    RUNTIME.GENDIALER_API_BASE_URL ||
    process.env.REACT_APP_GENDIALER_API_BASE_URL ||
    "https://gendialer.voiceracx.ai",
  App_URL: RUNTIME.App_URL || "https://vlmlite.voiceracx.ai",
  FB_APP_ID: RUNTIME.FB_APP_ID || "24067448326255766",
  GOOGLE_CLIENT_ID: RUNTIME.GOOGLE_CLIENT_ID || process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
  MICROSOFT_CLIENT_ID: RUNTIME.MICROSOFT_CLIENT_ID || process.env.REACT_APP_MICROSOFT_CLIENT_ID || "",
  MICROSOFT_TENANT_ID: RUNTIME.MICROSOFT_TENANT_ID || process.env.REACT_APP_MICROSOFT_TENANT_ID || "common",
  // Video App URL - can be different from BASE_URL
  VIDEO_APP_URL: "https://video-in-flex-functions-2927-dev.twil.io",
  // Chat microservice (used by in-app "Chat with Agent" and iframe widget)
  IFRAME_CHAT_URL: RUNTIME.IFRAME_CHAT_URL || "https://chat-microservice.voiceracx.ai",
  IFRAME_WEBSOCKET_URL: RUNTIME.IFRAME_WEBSOCKET_URL || "https://chat-microservice.voiceracx.ai",
  // Audio S3 Configuration
  AUDIO_S3_BUCKET: RUNTIME.AUDIO_S3_BUCKET || process.env.REACT_APP_AUDIO_S3_BUCKET || "vlmtestdata",
  AUDIO_S3_REGION: RUNTIME.AUDIO_S3_REGION || process.env.REACT_APP_AUDIO_S3_REGION || "us-east-1",
  AUDIO_S3_BASE_URL: RUNTIME.AUDIO_S3_BASE_URL || process.env.REACT_APP_AUDIO_S3_BASE_URL || "https://vlmtestdata.s3.us-east-1.amazonaws.com",
  AUDIO_S3_PATH: RUNTIME.AUDIO_S3_PATH || process.env.REACT_APP_AUDIO_S3_PATH || "Botnoi+Voices/A_Records",
};

const test = {
  API_ENDPOINT_URL: "/api",

  // Authentication URLs for testing
  AUTH_URL: "https://5540-103-182-158-109.ngrok-free.app",
  LOGIN_URL: "https://5540-103-182-158-109.ngrok-free.app/auth/login",

  // External Service URLs for testing
  SCHEDULER_URL:
    RUNTIME.SCHEDULER_URL ||
    process.env.REACT_APP_SCHEDULER_URL ||
    "https://gendialer.voiceracx.ai/auth/login?redirect=/gendialer/signin",
  FB_APP_ID: RUNTIME.FB_APP_ID || process.env.REACT_APP_FB_APP_ID || "YOUR_FB_APP_ID_HERE",
  GOOGLE_CLIENT_ID: RUNTIME.GOOGLE_CLIENT_ID || process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
  MICROSOFT_CLIENT_ID: RUNTIME.MICROSOFT_CLIENT_ID || process.env.REACT_APP_MICROSOFT_CLIENT_ID || "",
  MICROSOFT_TENANT_ID: RUNTIME.MICROSOFT_TENANT_ID || process.env.REACT_APP_MICROSOFT_TENANT_ID || "common",
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();
